import React, {useCallback, useMemo, useState} from 'react';
import {PasswordContainer} from '../../../../components/PasswordContainer';
import {SettingsPageContainer} from '../../../../components/Settings/SettingsPageContainer';
import {useFilterSelector} from '../../../../hooks/filter-selector';
import {ColumnModel, SettingsList} from '../../../../components/Settings/SettingsList';
import {BridgeDeviceModel} from '../../../../types/bridge-device';
import {useSetSelector} from '../../../../hooks/set-selector';
import {useLocalization} from "../../../../hooks/localization";

const keyExtractor = (item: BridgeDeviceModel) => item.id;

export function STPEditorListScreen() {
    const {t} = useLocalization();
    const stpDeviceList = useFilterSelector(state => state.control.bridgeDeviceList, (d) => d.type_id === '4' || d.type_id === '5' || d.type_id === '23' || d.type_id === '10');
    const deviceTypeSet = useSetSelector(state => state.control.bridgeDeviceTypeList);

    const [selectedMenuItem, setSelectedMenuItem] = useState<BridgeDeviceModel>(null);

    const buttons = useMemo(() => [
        {
            text: t('edit'),
            url: `/settings/stp-editor/${selectedMenuItem ? selectedMenuItem.id : ''}`,
            className: 'blue',
            hidden: !selectedMenuItem,
        },
    ], [t, selectedMenuItem]);

    const displayNameExtractor = useCallback((item: BridgeDeviceModel, column: ColumnModel) => {
        if (column.key === 'name') {
            return item.name || '-';
        }

        if (column.key === 'type') {
            return deviceTypeSet[item.type_id].name;
        }

        return item[column.key] || '-';
    }, [deviceTypeSet]);

    const columns = useMemo<ColumnModel[]>(() => [
        {
            length: 3,
            name: t('device_name'),
            key: 'name',
        },
        {
            length: 3,
            name: t('device_type'),
            key: 'type',
        },
    ], [t]);

    return (
        <PasswordContainer requiredRole="service" isFullscreen={true}>
            <SettingsPageContainer
                buttons={buttons}
                backUrl={'/settings'}
                searchable={true}>
                <SettingsList
                    columns={columns}
                    items={stpDeviceList}
                    selectedItem={selectedMenuItem}
                    onItemSelected={setSelectedMenuItem}
                    displayNameExtractor={displayNameExtractor}
                    keyExtractor={keyExtractor}/>
            </SettingsPageContainer>
        </PasswordContainer>
    );
}
